(() => {

    // Block Name
    const blockName = 'maps-gallery';

    // Variables
    let method = 'front';
    if (document.querySelector('body') == null || document.querySelector('body').classList.contains('wp-admin')) {
        method = 'wp-admin';
    }
    // -- end

    // Custom methods

    // -- end

    // Init blocks
    const initializeBlock = (block) => {
        if (block[0] !== undefined) block = block[0].querySelector(`.block-${blockName}`);
        if (block === false || block === null) return;


// === Scripts - START ===

// TABLE OF CONTENTS
        // Get div - tworzy spis treści w tym DIV:
        toc = document.getElementById("TOC");

        // Create a list for the ToC entries:
        tocList = document.createElement("ul");

        // ToC entries - zbiera nagłówki na podstawie klasy:
        headers = document.getElementsByClassName('block-inner-columns__title');

        // For each entry:
        for (i = 0; i < headers.length; i++) {
            // Create an id
            name = "h" + i;
            headers[i].id = name;

            // a list item for the entry
            tocListItem = document.createElement("li");

            // a link for the entry
            tocEntry = document.createElement("button");
            tocEntry.classList.add('scrollto__pill');
            tocEntry.setAttribute("data-scroll", name);
            tocEntry.innerText = headers[i].innerText;

            tocListItem.appendChild(tocEntry);
            tocList.appendChild(tocListItem);
        }
        toc.appendChild(tocList);

        // SCROLL TO
        var $ = jQuery.noConflict();
        $('#TOC .scrollto__pill').on('click', function () {
            let pageheader = $('.page-header').outerHeight();
            var trigger = $(this).data('scroll');

            var scrollto = $('.block-maps-gallery__listing-wrapper [id="' + trigger + '"]');

            $('html, body').animate({
                scrollTop: $(scrollto).offset().top - pageheader - 30
            }, 500);
        });
    };


// === Scripts - END ===

    // Get all blocks
    const getBlocks = () => {
        let blocks = document.querySelectorAll(`.block-${blockName}`);
        if (blocks.length > 0) {
            blocks.forEach((block) => {
                initializeBlock(block);
            });
        }
    };

    // Frontend
    document.addEventListener("DOMContentLoaded", getBlocks);

    // Acf Init
    window.addEventListener('load', (event) => {
        if (window.acf) {
            getBlocks();

            // Add update block action for ACF
            window.acf.addAction(`render_block_preview/type=${blockName}`, initializeBlock);
        }

    });

})();
